import { render, staticRenderFns } from "./LicensesForm.vue?vue&type=template&id=206a329e&scoped=true&"
import script from "./LicensesForm.vue?vue&type=script&lang=js&"
export * from "./LicensesForm.vue?vue&type=script&lang=js&"
import style0 from "./LicensesForm.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./LicensesForm.vue?vue&type=style&index=1&id=206a329e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206a329e",
  null
  
)

export default component.exports